<template>
  <div class="spl-datepicker">
    <datetime
      v-if="$mq === 'sm'"
      :value="date"
      :auto="true"
      :format="luxonFormat"
      :min-datetime="disabledDates.to ? moment(disabledDates.to).add(2, 'hours').toISOString(true) : null"
      :max-datetime="disabledDates.from ? moment(disabledDates.from).add(2, 'hours').toISOString(true) : null"
      :type="type"
      :class="{'spl-datepicker--valid': !invalid, 'spl-datepicker--invalid': invalid}"
      input-class="spl-input"
      value-zone="local"
      @input="onPhoneDateSelected" />
    <div v-else>
      <the-mask
        ref="dateInputField"
        :mask="type === 'date' ? '####-##-##' :'####-##-## ##:##'"
        :value="dateInput"
        :masked="true"
        :placeholder="type === 'date' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:MM'"
        :class="{'spl-datepicker--valid': !invalid, 'spl-datepicker--invalid': invalid}"
        class="spl-input"
        type="text"
        @focus.native="onOpenClassicPicker"
        @blur.native="onCloseClassicPicker"
        @keyup.native.enter="enterPressed"
        @input="onDesktopDateInput" />
      <datepicker
        ref="desktopPicker"
        :format="luxonFormat"
        :monday-first="true"
        :typeable="true"
        :value="date"
        :disabled-dates="disabledDates"
        class="spl-classic-datepicker"
        input-class="spl-input"
        name="spl-input"
        @selected="onDesktopDateSelected" />
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'

export default {
  name: 'FormDatepicker',
  components: {
    Datepicker
  },
  props: {
    value: {
      default: moment().toISOString(true)
    },
    type: {
      type: String,
      default: 'date'
    },
    min: {
      default: null
    },
    max: {
      default: null
    },
    index: {
      type: Number,
      default: NaN
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      date: null,
      dateInput: null,
      disabledDates: { from: null, to: null },
      luxonFormat: this.type === 'date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm',
      momentFormat: this.type === 'date' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm',
      moment
    }
  },
  watch: {
    value () {
      if (moment(this.value).toISOString(true) !== this.date) {
        this.date = moment(this.value).toISOString(true)
        this.dateInput = moment(this.date).format(this.momentFormat)
      }
    },
    dateInput () {
      var convertedDate = moment(this.dateInput, this.momentFormat)
      if (convertedDate.toISOString(true) !== this.date) {
        this.date = convertedDate.toISOString(true)
      }
    }
  },
  mounted () {
    this.date = this.value
    this.dateInput = moment(this.date).format(this.momentFormat)

    if (this.min) {
      this.disabledDates.to = moment(this.min).toDate()
    }
    if (this.max) {
      this.disabledDates.from = moment(this.max).toDate()
    }
    this.$watch('date', function () {
      this.$emit('input', this.date, this.index)
    })
  },
  methods: {
    onDesktopDateSelected (date) {
      var convertedDate = moment(date)
      convertedDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      this.dateInput = convertedDate.format(this.momentFormat)
      this.date = convertedDate.toISOString(true)
      if (this.type === 'date') {
        this.$refs.dateInputField.$el.blur()
      } else {
        setTimeout(() => {
          this.$refs.dateInputField.$el.setSelectionRange(
            this.dateInput.length - 5,
            this.dateInput.length - 5
          )
        }, 0)
      }
    },
    onCloseClassicPicker () {
      this.$refs.desktopPicker.close()
      this.$emit('blur')
    },
    onOpenClassicPicker () {
      this.$refs.desktopPicker.showCalendar()
    },
    onDesktopDateInput (value) {
      this.dateInput = value
    },
    onPhoneDateSelected (value) {
      this.date = moment(value).toISOString(true)
    },
    enterPressed () {
      this.$refs.dateInputField.$el.blur()
    }
  }
}
</script>

<style lang="scss">
@import "../../variables.scss";
.spl-datepicker {
  &--invalid,
  &--invalid input {
    background-color: $redBackgroundLight;
    border-color: $errorRed;
  }

  &--valid,
  &--valid input {
    background-image: url(../../assets/icon-check.svg);
    background-position: right 10px center;
    background-repeat: no-repeat;
  }

  margin-bottom: 10px;
  .vdp-datepicker {
    & .spl-input {
      display: none;
    }

    &__calendar {
      border-radius: 4px;

      & .cell {
        &.sat {
          background-color: $grey_95;
          border-radius: 0;
        }
        &.sun {
          background-color: $grey_90;
          border-radius: 0;
        }
        &.today {
          background-color: $yellow_80;
        }
        &.selected,
        &.selected:hover {
          background-color: $middleYellow;
        }

        &:not(.blank):not(.disabled).day:hover {
          border: 1px solid $middleYellow;
        }
      }
    }
  }
  .vdatetime {
    &-overlay {
      z-index: 9999999;
    }
    &-popup {
      z-index: 99999999;
    }
  }
}
</style>
